import { ComboBoxComponent, DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { ComboBox } from '@syncfusion/ej2-angular-dropdowns';
import { forkJoin, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { ApiResponse, Companies, UserRoles } from 'projects/service/src/app/shared/models/app.model';
import { CommonService } from 'projects/service/src/app/shared/services/common.service';
import {
  CallGroups,
  GeneralSectionData,
  ModeList,
  serviceOrderStatuses,
} from '../../../models/service-order.model';
import { EquipmentInformationSectionService } from '../../../services/equipment-information-section.service';
import { GeneralSectionService } from '../../../services/general-section.service';
import { ServiceOrderService } from '../../../services/service-order.service';
import { SoDetailsTabService } from '../../../services/so-details-tab.service';
import { TimeAgoPipe } from 'projects/service/src/app/shared/pipes/time-ago.pipe';
import { MasterItemcodePopupComponent } from 'projects/shared/src/lib/components/master-itemcode-popup/master-itemcode-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-so-details-tab',
    templateUrl: './so-details-tab.component.html',
    styleUrls: ['./so-details-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SoDetailsTabComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroy$: Subject<null> = new Subject();

  @ViewChild('serialNumberSearch') serialNumberDropdown: DropDownListComponent;
  @ViewChild('objectsDDL') objectsDDL: DropDownListComponent;
  @ViewChild('configurationsDDL') configurationsDDL: DropDownListComponent;
  @ViewChild('callgroupCombo') callgroupCombo: ComboBox;
  @ViewChild('reasonsDDL') reasonsDDL;

  @Input() eqData = null;
  @Input() isEditable: boolean = true;
  @Input() fieldRules: any;
  // @Input() equipmentServiceDepartment = null;
  @Input() serviceDepartment = null;
  @Input() paymentButtonClicked = false;
  
  isSerialNumberEnabled: boolean = false;
  isModelEnabled: boolean = false;

  showAdvancedSearch: boolean = false;
  fromCustomerAdvancedSearch: boolean = false;
  validationApplied: boolean = false;
  skipValidationOnSerialForKL: boolean = false;
  showAdvancedSearchForSerialNumbers: boolean = false;
  fromSerialNumberAdvanceSearch: boolean = false;
  fromSerailNumberDDLChange: boolean = false;
  isDataReceived: boolean = false;
  today = new Date();
  customerAddress: string = '';
  serviceDepartments = [];
  configurations: any = [];
  priorities = [];
  objects = [];
  signals = [];
  serialNumbers = [];
  callgroups = [];
  serviceOrderStatuses = serviceOrderStatuses;

  @Input() id: string = null;
  @Input() gsData: GeneralSectionData = null;
  @Input() notesData: any = null;
  @Input() hasAssignments: boolean = false;
  @Input() hasCheckedInServiceOrder: boolean = false;
  @Input() status: string = serviceOrderStatuses.open;
  @Input() reasonsForCancellation: any = [];
  @Input() showActivateEquipmentCheckbox: boolean = false;
  
  @Output() statusChanged: EventEmitter<any> = new EventEmitter();
  @Output() distanceZoneChanged: EventEmitter<any> = new EventEmitter();
  @Output() configurationChanged: EventEmitter<any> = new EventEmitter();
  @Output() checkedIn: EventEmitter<any> = new EventEmitter();
  @Output() checkedOut: EventEmitter<any> = new EventEmitter();
  hasTransaction: boolean = false;
  canCheckin: boolean = false;
  reasonsForPause: any = [];
  model: any;
  serialNumber: any;
  formatedElapsedTime: any;
  USER: any;
  userRoles;
  isTechnician: boolean = false;
  isCsa: boolean = false;
  isIsc: boolean = false;
  isIscManager: boolean = false;

  warrantyInfo: any;
  contractInfo: any;

  selectedModelNumber: string = null;
  selectedSerialNumber: string = null;

  isKingslynn: boolean = true;
  serialNumberReadOnly: boolean = false;
  itemCodeReadOnly: boolean = false;
  referenceReadOnly: boolean = false;
  priorityReadOnly: boolean = false;
  callGroupReadOnly: boolean = false;
  startDateReadOnly: boolean = false;
  customerComplaintReadOnly: boolean = false;
  fstCommentsToCustomerReadOnly: boolean = false;
  checkInDateReadOnly: boolean = false;
  checkOutDateReadOnly: boolean = false;
  customerCodeReadOnly: boolean = false;
  reasonCodeReadOnly: boolean = false;
  refrenceInputLengthValidation: boolean = true;

  constructor(
    private serviceOrderService: ServiceOrderService,
    private generalSectionService: GeneralSectionService,
    private dialog: MatDialog,
    private commonService: CommonService,
    private soDetailsTabService: SoDetailsTabService
  ) {
    this.USER = commonService.USER;
    this.isIsc = commonService.USER.role === UserRoles.isc;
    this.isIscManager = commonService.USER.role === UserRoles.iscManager;
    this.isTechnician = this.USER.role === UserRoles.fst;
    this.serialNumberReadOnly = this.commonService.roleClaims['SO_Popup_Field_serialNumber']?.readOnly;
    this.itemCodeReadOnly = this.commonService.roleClaims['SO_Popup_Fields_itemCode']?.readOnly;
    this.referenceReadOnly = this.commonService.roleClaims['SO_Popup_Fields_reference']?.readOnly;
    this.priorityReadOnly = this.commonService.roleClaims['SO_Popup_Fields_priority']?.readOnly;
    this.callGroupReadOnly = this.commonService.roleClaims['SO_Popup_Fields_callGroup']?.readOnly;
    this.startDateReadOnly = this.commonService.roleClaims['SO_Popup_Fields_startDate']?.readOnly;
    this.customerComplaintReadOnly = this.commonService.roleClaims['SO_Popup_Field_customerComplaint']?.readOnly;
    this.fstCommentsToCustomerReadOnly = this.commonService.roleClaims['SO_Popup_Field_fstCommentsToCustomer']?.readOnly;
    this.checkInDateReadOnly = this.commonService.roleClaims['SO_Popup_Fields_checkInDate']?.readOnly;
    this.checkOutDateReadOnly = this.commonService.roleClaims['SO_Popup_Fields_checkOutDate']?.readOnly;
    this.reasonCodeReadOnly = this.commonService.roleClaims['SO_Popup_Fields_reasonCode']?.readOnly;
    this.customerCodeReadOnly = this.commonService.roleClaims['SO_Popup_Fields_customerCode']?.readOnly;
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //     if (changes && changes.data && !changes.data.firstChange && changes.data.currentValue) {
  //         this.eqData = changes.data.currentValue;
  //         this.setEquipmentPageData(); //setNotesData formerly
  //         this.serialNumbers = [];
  //     }
  // }


  ngOnChanges(change: SimpleChanges) {
      if (change && change.gsData) {
        this.gsData = change.gsData.currentValue;
        const timeAgoPipe = new TimeAgoPipe();
        this.formatedElapsedTime = timeAgoPipe.transform(this.gsData?.elapsedTime);
      }

      if (change && change.id) {
          if(!change.id.previousValue && change.id.currentValue){
              this.canCheckin = this.canUserCheckin();
          }
      }

      if (change && change.status) {
          this.status = change.status.currentValue;
          this.canCheckin = this.canUserCheckin();
          if (change.status.previousValue !== undefined && change.status.previousValue !== change.status.currentValue) {
              // A status change sets the check-in / check-out times and tells the popup (setCheckIn / setCheckOut).
              // The Syncfusion pickers used to tell it from their change event, which also fired on every reload of
              // the order and looped the popup's save (2026-10-31).
              if (change.status.currentValue === serviceOrderStatuses.inProgress) {
                  this.setCheckIn(new Date());
                  this.setCheckOut(null);
              } else if (change.status.currentValue === serviceOrderStatuses.enroute) {
                  this.gsData.startDate = new Date();
              } else if (change.status.currentValue === serviceOrderStatuses.scheduled) {
                  this.setCheckIn(null);
                  this.setCheckOut(null);
              } else if (change.status.currentValue === serviceOrderStatuses.paused || change.status.currentValue === serviceOrderStatuses.awaitingPayment) {
                  this.gsData.startDate = null;
                  if(change.status.previousValue !== serviceOrderStatuses.open){
                    this.setCheckOut(new Date());
                  }
              } else if (change.status.currentValue === serviceOrderStatuses.open) {
                  this.commonService.showConfirmation('Time details will be reset do you want to proceed?')
                      .then(result => {
                          if (result.isConfirmed) {
                              this.setCheckIn(null);
                              this.setCheckOut(null);
                              this.gsData.startDate = null;
                          } else {
                              this.changeStatus(serviceOrderStatuses[change.status.previousValue.toLowerCase()]);
                          }
                      });
              } else if (change.status.currentValue === serviceOrderStatuses.pendingApproval) {
                  this.gsData.startDate = null;
                  this.setCheckOut(new Date());
              } else if (change.status.currentValue === serviceOrderStatuses.completed) {
                  this.setCheckOut(new Date());
              } else if (change.status.currentValue === serviceOrderStatuses.cancelled) {
                  this.gsData.startDate = null;
                  this.setCheckOut(new Date());
              }
          }
      }
  }

  ngAfterViewInit(): void {
    if (this.gsData && this.gsData.configuration) {
      this.updateConfigurationDDL(
          this.gsData.configuration,
          this.gsData.customerDescription
      );
    }

    if (this.eqData && this.eqData.itemCode) {
      this.updateModelDDL(
          this.eqData.itemCode,
          this.eqData.itemDescription
      );
    }

    if (this.gsData?.fromEquipment && this.eqData?.serialNumber) {
      this.serialNumbers = [{
        value: this.eqData.serialNumber,
        text: this.eqData.serialNumber,
        serialNumber: this.eqData.serialNumber
      }];
      if (this.serialNumberDropdown) {
        this.serialNumberDropdown.dataSource = this.serialNumbers;
        this.serialNumberDropdown.value = this.eqData.serialNumber;
      }
    }
  }

  getDropdownListsForCreate() {
    this.loadCommonFields();
    this.serviceOrderService.popupLoader.next(true);
    const searchText = this.gsData?.fromEquipment ? (this.gsData.customerCode || null) : null;
    const apis = [
      this.serviceOrderService.getConfigurations(this.serviceDepartment, this.USER.company, searchText),
    ];
    forkJoin(apis).subscribe((res: any) => {
      res[0]?.result && this.loadConfigurations(res[0]);
      if (this.gsData?.fromEquipment) {
        this.applyEquipmentPrefill(res[0]);
      }
      // Load Serial number API will called onSerialNumberCreated event
    });
  }

  applyEquipmentPrefill(configRes: any) {
    if (configRes?.isSuccessful && configRes.result?.length) {
      const row = configRes.result.find((r: any) => r.soldToBP === this.gsData.customerCode) || configRes.result[0];
      if (row) {
        this.gsData.configuration = row.cluster;
        this.gsData.customerCode = row.soldToBP;
        this.gsData.customerDescription = row.soldToBP + ' - ' + row.bpDescription;
        this.updateConfigurationDDL(row.cluster, this.gsData.customerDescription);
        this.getCustomerByConfiguration(row.cluster, 'fromEquipment');
      }
    } else if (this.gsData?.customerCode) {
      this.updateConfigurationDDL(this.gsData.customerCode, this.gsData.customerDescription);
      this.gsData.configuration = this.gsData.customerCode;
    }

    if (this.eqData?.itemCode) {
      this.updateModelDDL(this.eqData.itemCode, this.eqData.itemDescription);
    }
    if (this.eqData?.serialNumber) {
      this.serialNumbers = [{
        value: this.eqData.serialNumber,
        text: this.eqData.serialNumber,
        serialNumber: this.eqData.serialNumber
      }];
      if (this.serialNumberDropdown) {
        this.serialNumberDropdown.dataSource = this.serialNumbers;
        this.serialNumberDropdown.value = this.eqData.serialNumber;
      }
    }
  }

  ngOnInit(): void {
    this.userRoles = UserRoles;
    this.USER = this.commonService.USER;
    this.isKingslynn = this.USER.company === Companies.kingslynn;

    if (this.gsData?.fromEquipment) {
      this.customerCodeReadOnly = true;
      this.itemCodeReadOnly = true;
      this.serialNumberReadOnly = true;
    }

    this.setModelEnabled();
    this.setSerialNumberEnabled();
    this.skipValidationOnSerialForKL = this.isKingslynn && this.gsData?.callGroup === CallGroups.initialCalibration;
    this.setSubscriptions(); // For hasTransactions, Customer and Serial DDL Filtering

    if (!this.id) {
      this.getDropdownListsForCreate();
    } else {
      this.initailizeGeneralSectionData();
      this.setEquipmentPageData();
      this.loadCommonFields();
      // Load Serial number API will called onSerialNumberCreated event
      // We are populating Configuration & Model DDL in ngAfterViewInit() method
      this.setNotesData();
    }
    
    const timeAgoPipe = new TimeAgoPipe();
    this.formatedElapsedTime = timeAgoPipe.transform(this.gsData?.elapsedTime);
  }

  /**
   * We are setting all the subscriptions for the details tab
   * hasTransaction: its value will be updated if we change anything from the Second grid in the execution tab
   */
  setSubscriptions() {
    this.serviceOrderService.hasTransaction.pipe(
      takeUntil(this.destroy$),
    ).subscribe(hasTransaction => {
        this.hasTransaction = hasTransaction;
    });

    this.serviceOrderService.getSearchCustomerFiltering().pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      ).subscribe(value => {
        if ( !value ) {
          this.gsData.customerDescription = null;
          this.getConfigurations('', true);
        }
        this.getConfigurations(value);
      });

    this.serviceOrderService.getSrNumberFiltering().pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      ).subscribe(filteredString => {
        this.getSerialNumbersDDL(filteredString, 'on serial number filtering');
      });
  }

  setEquipmentPageData() {
    if (!this.eqData) {
    } else {
        this.selectedModelNumber = this.eqData.itemCode;
        this.selectedSerialNumber = this.eqData.serialNumber;
        this.getWarrantyAndContract();
        if (!this.selectedSerialNumber) {
            this.warrantyInfo = null;
            this.contractInfo = null;
        }
    }
  }

  validateEquipmentSectionData(onInvoicePaymentValidate: boolean = false) {
      this.validationApplied = true;
      const isEquipmentActivatedCheck = onInvoicePaymentValidate && this.eqData.isChargeBeeModel && this.eqData.callgroup === CallGroups.installation && !this.eqData.isEquipmentActivated;
      if (!this.eqData.itemCode || (!this.eqData.serialNumber && !this.skipValidationOnSerialForKL) || isEquipmentActivatedCheck) {
        return false;
      } else 
        return true;
  }

  onObjectChange(args: any) {
    // 'Model changed'
    if ( args.isInteracted ) {
        const model = args.value;
        const modelDescription = args.itemData.description;
        this.setModelSerialValues(model, modelDescription, '', 'on model/object change');
        this.eqData.serializedItemGroupCode = args.itemData.serializedItemGroupCode;
        this.eqData.serializedItemGroupDescription = args.itemData.serializedItemGroupDescription;

      this.getSerialNumbersDDL(null, 'on object/model change');
    } else if ( this.fromCustomerAdvancedSearch ) {
      if ( !args.value ) {
        this.resetModelRelatedFieldsForNull();
      } else {

      }
    } else if ( this.fromSerialNumberAdvanceSearch ) {
      if ( !args.value ) {
        this.resetModelRelatedFieldsForNull();
      }  else {
        this.updateModelRelatedFields(args)
      }
      this.fromSerialNumberAdvanceSearch = false;
    } else if (this.fromSerailNumberDDLChange) {
      this.fromSerailNumberDDLChange = false;
      this.updateModelRelatedFields(args);
    } else { // model changed from popup open, or customer interaction
      if ( !args.value ) {
        this.resetModelRelatedFieldsForNull();
      } else {
        this.updateModelRelatedFields(args)
      }
    }
  }

  updateModelRelatedFields(args) {
    this.eqData.itemCode = args.value;
    this.eqData.itemDescription = args.itemData.description;
    this.eqData.serializedItemGroupCode = args.itemData.serializedItemGroupCode;
    this.eqData.serializedItemGroupDescription = args.itemData.serializedItemGroupDescription;
  }

  resetModelRelatedFieldsForNull() {
    this.eqData.serializedItemGroupDescription = null;
    this.eqData.serializedItemGroupCode = null;
    // ('Reset Model related fields');
  }

  getModelsDDL(configuration: string = '', src?: string) {
    this.objects = [];
    this.soDetailsTabService.getObjects(configuration, this.serviceDepartment)
        .subscribe((res: ApiResponse) => {
            res.result.map(row => {
                row.text = row.value + " - " + row.description;
            });
            this.objects = res.result && res.result.length ? res.result : [];
        });
  }

  showMasterItemCodePopup(eqData: any) {
    if (!eqData?.itemCode) return;
    const dialogRef = this.dialog.open(MasterItemcodePopupComponent, {
      panelClass: 'master-itemcode-popup-dialog',
      width: '80%',
      height: '80%',
      data: eqData
    });
    dialogRef.afterClosed().subscribe((result) => { });

  }

  onModelDDLCreated() {
    // ('model created');
  }

  onSerialNumberCreated() {
    
    if ( this.commonService.USER.role !== UserRoles.iscManager && this.commonService.USER.role !== UserRoles.isc && this.commonService.USER.role !== UserRoles.IscSupervisor) {
        this.soDetailsTabService.getSerialNumbersForSearch(this.serviceDepartment, this.USER.company, this.gsData.configuration, this.eqData.itemCode, '', this.gsData.offlineOrder)
        .subscribe((res: ApiResponse) => {
            if (res && res.result) {
                res.result.map((row) => {
                    row.text = row.alternateSerialNumber.trim() ? row.serialNumber + ' - ' + row.alternateSerialNumber.trim() : row.serialNumber;
                    row.value = row.serialNumber;
                });
                this.serialNumbers = res.result;
            }
        });
    }
  }

  getSerialNumbersDDL(searchString?: string, src?:string) {
    // (`getSerialNumbersDDL() API call (EquipmentObject/GetSerialNumberSearchView): SRC: [${src}], search string: ${searchString}, params: [serviceDept: ${this.serviceDepartment}, company: ${this.USER.company}, configuration: ${this.gsData.configuration}, itemCode: ${this.eqData.itemCode}]`);
    this.soDetailsTabService.getSerialNumbersForSearch(this.serviceDepartment, this.USER.company, this.gsData.configuration, this.eqData.itemCode, searchString, this.gsData.offlineOrder)
        .subscribe((res: any) => {
            if (res && res.result ) {
                res.result.map((row) => {
                    row.text = row.alternateSerialNumber.trim() ? row.serialNumber + ' - ' + row.alternateSerialNumber.trim() : row.serialNumber;
                    row.value = row.serialNumber;
                });
                if (searchString && !res.result.length) {
                  // if serial is already selected and we try to filter, it was resetting the data source to [], and value gets updated as null, this is to avoid reset DS to null
                } else {
                  this.serialNumberDropdown.dataSource = this.serialNumbers = res.result;
                }
            }
            this.serviceOrderService.popupLoader.next(false);
        });
  }

  onSerialNumberChange(args: any, src?: string) {
    if (args.isInteracted) {
      const data = args.itemData;
      this.fromSerailNumberDDLChange = true;
      // (`getSerialNumbersDDL() API call (EquipmentObject/GetSerialNumberSearchView): SRC: [${src}], params: [serviceDept: ${this.serviceDepartment}, company: ${this.USER.company}, configuration: ${data.configuration}, itemCode: ${data.model}]`);
      // ('serial number interacted');
      // check if customer and model are selected already or not
      if ( this.gsData.configuration ) { // means model and serial is filtered according to customer
          if ( this.eqData.itemCode ) { // means serial number is already filtered according to model and customer
            this.eqData.serialNumber = data.serialNumber; //then, set serial only
          } else { // means model is filtered but not selected, we need to filter serial based on model
            this.objectsDDL.value = this.eqData.itemCode = data.model; // set model and get filtered serial
            this.soDetailsTabService.getSerialNumbersForSearch(this.serviceDepartment, this.USER.company, data.configuration, data.model, null, this.gsData.offlineOrder)
            .subscribe((res: ApiResponse) => {
              if (res && res.result ) {
                res.result.map((row) => {
                    row.text = row.alternateSerialNumber.trim() ? row.serialNumber + ' - ' + row.alternateSerialNumber.trim() : row.serialNumber;
                    row.value = row.serialNumber;
                });
                this.setWorkSiteAddress(data);

                this.serialNumbers = res.result;
              }
              this.eqData.serialNumber = data.serialNumber;
            });
          }
        } else {
          this.updateModelCustomerAfterSerialChange(data);
        }

        this.objectsDDL.value = this.eqData.itemCode = data.model;
        this.updateSerialNumberRelatedData(args.itemData);
        this.getWarrantyAndContract();
        // this.serviceOrderService.serialNumberChange.next(args);
    } else if ( this.fromSerialNumberAdvanceSearch ) {
      // ('serial changed from advance search', args.value);
      if ( !args.value ) {
        // ('Reset Serial Number Related Fileds including Warranty and Contract Information');
        this.resetSerialNumberFieldsForNull();
      } else {
        this.updateSerialNumberRelatedData(args.itemData)
      }
    } else {
      // ('serial changed on model, customer change or on popup open', args.value);
      if ( !args.value ) {
        this.resetSerialNumberFieldsForNull();
        // ('Reset Serial Number Related Fileds including Warranty and Contract Information');
      } else {
        this.updateSerialNumberRelatedData(args.itemData)
      }
    }
  }

  setWorkSiteAddress(data) {
    // replace customer address by worksite address based on serialnumber
    if(data.address && data.addressCode) {
      this.gsData.customerDescription = data.customerId + ' - ' + data.customerName;
      this.gsData.address = data.address;
      this.gsData.addressCode = data.addressCode;
      this.gsData.city = data.city;
      this.gsData.country = data.country;
      this.gsData.customerCode = data.customerId;
      this.gsData.zipCode = data.zipCode;
      this.gsData.customerPhoneNumber = data.phoneNumber;
      this.gsData.state = data.stateProvince;
    }
  }

  resetSerialNumberFieldsForNull() {
    this.eqData.serialNumber = null;
    this.eqData.installationDate = null;
    this.eqData.warrantyCode = null;
    this.eqData.warrantyDescription = null;
    this.eqData.warrantyDescriptionObj = null;
    this.eqData.serviceContractCode = null;
    this.eqData.serviceContractDescription = null;
    this.eqData.serviceContractDescriptionObj = null;
    this.eqData.calibrationNextCertificateDate = null;
    localStorage.setItem('warranty', '');
    localStorage.setItem('contract', '');
    this.commonService.warantyInfo = null;
    this.commonService.contractInfo = null;
    if (this.warrantyInfo || this.contractInfo) {
        this.serviceOrderService.equipmentInfoSubject.next({ data: this.eqData, warrantyInfo: '', contractInfo: '' });
    }
  }

  onConfigurationFiltering(args) {
    this.serviceOrderService.setSearchCustomerFiltering(args.text); //searched text
  }

  onSerialNumberFiltering(args: any) {
    this.serviceOrderService.setSrNumberFiltering(args.text);
  }

  setCoverageClasses(data) {
    let warrantyDescriptionObj = data?.warrantyDescriptionObj ?? data?.result?.warrantyDescriptionObj;
    let serviceContractDescriptionObj = data?.serviceContractDescriptionObj ?? data?.result?.serviceContractDescriptionObj;
    if (warrantyDescriptionObj && warrantyDescriptionObj.length) {
        warrantyDescriptionObj.map(war => {
            war['class'] = this.getWarrantyClass(war);
        });
        this.warrantyInfo = warrantyDescriptionObj;
    }
    if (serviceContractDescriptionObj && serviceContractDescriptionObj.length) {
        serviceContractDescriptionObj.map(con => {
            con['class'] = this.getWarrantyClass(con);
        });
        this.contractInfo = serviceContractDescriptionObj;
    }
  }

  getWarrantyClass(data) {
    const created = new Date(this.eqData.soCreatedDate), expiryDate = new Date(data?.expiryDate);
    created.setHours(0,0,0,0);
    expiryDate.setHours(0,0,0,0);
    let after30days = new Date(); after30days.setDate(after30days.getDate() + 30);
    let warrantyClass = '';
    if (expiryDate < created) {
        warrantyClass = 'bg-danger';
    } else if (expiryDate <= after30days && expiryDate >= created) {
        warrantyClass = 'bg-warning';
    } else {
        warrantyClass = 'bg-success';
    }
    return warrantyClass;
  }

  getWarrantyAndContract() {
    if ( [serviceOrderStatuses.completed, serviceOrderStatuses.cancelled].includes(this.eqData.status) ) {
        const warrantyInfo = this.warrantyInfo || JSON.parse(this.eqData.warrantyCoverageLines);
        const contractInfo = this.contractInfo || JSON.parse(this.eqData.contractCoverageLines);
        this.setCoverageClasses({
            warrantyDescriptionObj: warrantyInfo,
            serviceContractDescriptionObj: contractInfo
        });

        this.serviceOrderService.equipmentInfoSubject.next({ data: this.eqData, warrantyInfo, contractInfo });
    } else {
        const modelId = this.eqData.itemCode ? this.eqData.itemCode : this.selectedModelNumber ? this.selectedModelNumber : null;
        if ( this.eqData?.warrantyCode && this.eqData?.serialNumber ) {
            this.soDetailsTabService.getContractAndWarranty(modelId, this.eqData.serialNumber, this.eqData.serviceContractCode, this.eqData.warrantyCode, this.USER.company, this.eqData.serviceTypeCode, this.eqData.soCreatedDate)
                .subscribe((res: any) => {
                    if (res.isSuccessful) {
                        this.setCoverageClasses(res.result);
                        if (this.warrantyInfo || this.contractInfo) {
                            this.serviceOrderService.equipmentInfoSubject.next({ data: this.eqData, warrantyInfo: this.warrantyInfo, contractInfo: this.contractInfo });
                        }
                    } else {
                        this.commonService.showNotification('error', 'There was some issue during fetching the data. Kindly, check the data and try again.');
                    }
                    this.serviceOrderService.popupLoader.next(false);
                }, error => {
                    this.commonService.showNotification('error', 'There was some issue during fetching the data. Kindly, check the data and try again.');
                    this.serviceOrderService.popupLoader.next(false);
                });
        }
    }
  }

  updateSerialNumberRelatedData(data) {
    if (data) {
        this.eqData.serialNumber = data.serialNumber;
        this.eqData.installationDate = data.installationDate ? data.installationDate : data.installationTime ? data.installationTime : null;
        this.eqData.warrantyCode = data.warrantyCode;
        this.eqData.warrantyDescription = data.warrantyDescription;
        this.eqData.warrantyDescriptionObj = this.warrantyInfo || data.warrantyDescriptionObj;
        this.eqData.serviceContractCode = data.serviceContractCode;
        this.eqData.serviceContractDescription = data.serviceContractDescription;
        this.eqData.serviceContractDescriptionObj = this.contractInfo || data.serviceContractDescriptionObj;
        //this.eqData.calibrationNextCertificateDate = data.calibrationNextCertificateDate;
        this.eqData.calibrationNextCertificateDate = data.calibrationNextCertificateDate ?? this.eqData.calibrationNextCertificateDate;
        localStorage.setItem('warranty', data.warrantyDescription || '');
        localStorage.setItem('contract', data.serviceContractDescription || '');
        this.commonService.warantyInfo = data.warrantyDescription;
        this.commonService.contractInfo = data.serviceContractDescription;
        if (this.warrantyInfo || this.contractInfo) {
            this.serviceOrderService.equipmentInfoSubject.next({ data, warrantyInfo: this.warrantyInfo, contractInfo: this.contractInfo });
        }
    }
  }

  setSerialNumberEnabled() {
    if (this.gsData?.fromEquipment) {
      this.isSerialNumberEnabled = false;
      return;
    }
    const readonlyUsingClaimRoles = this.serialNumberReadOnly;
    const enabledForKingslynn = this.isKingslynn && this.gsData.callGroup === CallGroups.commissionInstall && !this.eqData.serialNumber;
    this.isSerialNumberEnabled = (this.eqData?.offlineOrder || enabledForKingslynn) && !this.hasTransaction ? this.isEditable || !readonlyUsingClaimRoles : false;
  }

  setModelEnabled() {
    if (this.gsData?.fromEquipment) {
      this.isModelEnabled = false;
      return;
    }
    const readonlyUsingClaimRoles = this.itemCodeReadOnly;
    const enabledForKingslynn = this.isKingslynn && this.gsData.callGroup === CallGroups.commissionInstall && !this.eqData.itemCode;
    this.isModelEnabled = (this.eqData?.offlineOrder || enabledForKingslynn) && (this.isEditable || !readonlyUsingClaimRoles);
  }

  refrenceChanged(event){
    this.gsData.reference = event.value;
    this.refrenceInputLengthValidation = this.validateReference();
  }

  toggleCheckin() {
    if (this.isEditable && this.refrenceInputLengthValidation) {
      if (!this.status) {
        this.status = this.gsData && this.gsData.status ? this.gsData.status : serviceOrderStatuses.open;
      }
      const restrictedCheckinStatuses = [serviceOrderStatuses.inProgress, serviceOrderStatuses.completed, serviceOrderStatuses.cancelled];
      if ( !restrictedCheckinStatuses.includes(this.status) ) {
        if (this.isKingslynn && this.gsData.callGroup === CallGroups.commissionInstall && !(this.eqData.serialNumber && this.eqData.itemCode)) {// ticket 3609: Requirements Updated
            this.commonService.showNotification('error', 'Cannot check-in due to blank model/serial number.');
        } else {
          this.gsData.checkInDate = this.gsData.startDate = new Date();
          this.gsData.mode = this.gsData.nteAmount && this.status === serviceOrderStatuses.open ? ModeList.estimate : this.gsData.mode;
          this.changeStatus(serviceOrderStatuses.inProgress);
        }
      } else if (this.status === serviceOrderStatuses.inProgress) {
        if (this.hasAssignments) {
          this.commonService
            .showConfirmation(
              'Do you want to change the status to awaiting payment?'
            )
            .then((result) => {
              if (result.isConfirmed) {
                this.gsData.checkOutDate = new Date();
                this.changeStatus(serviceOrderStatuses.awaitingPayment);
              } else if (result.isDenied) {
                this.gsData.checkOutDate = new Date();
                this.changeStatus(serviceOrderStatuses.paused);
              }
            });
        } else {
          this.commonService
            .showConfirmation(
              'There are no assignments added yet, status will be change to paused. Do you want to proceed?'
            )
            .then((result) => {
              if (result.isConfirmed) {
                this.gsData.checkOutDate = new Date();
                this.changeStatus(serviceOrderStatuses.paused);
              }
            });
        }
      }
    }
  }

  reasonChange(args: any) {
    this.gsData.reasonCode = args.value;
    this.gsData.reasonDescription = args.itemData.description;
  }

  getConfigurations(searchText: string, openDropdown: boolean = false) {
    // this.serviceOrderService.popupLoader.next(true);
    this.serviceOrderService.getConfigurations(
        this.serviceDepartment,
        this.USER.company,
        searchText
      ).subscribe((res: ApiResponse) => {
        res.result.map((row) => {
          row.text = row.soldToBP + ' - ' + row.bpDescription;
          row.value = row.cluster;
        });
        if (searchText && !res.result.length) {
          // if customer is already selected and we try to filter, it was resetting the data source to [], and value gets updated as null, this is to avoid reset DS to null
        } else {
          this.configurationsDDL.dataSource = this.configurations = res.result;
        }
        // this.serviceOrderService.popupLoader.next(false);
      });
  }

  // The check-out time set by a status change, passed to the popup (assignment and transaction end times).
  private setCheckOut(date: Date | null) {
    this.gsData.checkOutDate = date;
    this.checkedOut.next(date);
  }

  // The check-in time set by a status change, passed to the popup, which fills the start times and saves. The
  // Check-in field is read-only, so this runs only when the app sets the time, never when the order is reloaded.
  private setCheckIn(date: Date | null) {
    this.gsData.checkInDate = date;
    if (date) {
      this.gsData.startDate = date;
    }
    this.checkedIn.next(date);
  }

  nteChangeTrigger(args) {
    this.gsData.nteAmount = args.value;
    this.gsData.approvedAmount = args.value;
    this.serviceOrderService.nteChange.next(args);
  }

  setAssignments(hasAssignments: boolean) {
    this.hasAssignments = hasAssignments;
  }

  onStartDateCreated(event: any) {
    if (this.id) {
      if (this.gsData.startDate) {
        if (this.gsData.status) {
          this.today = new Date();
        } else {
          this.today = new Date(this.gsData.startDate);
        }
      } else {
        this.today = new Date();
      }
    } else {
      this.today = new Date();
    }
  }

  onStartDateChange(event: any) {
    if (event.isInteracted) {
      if (
        !this.gsData.startDate ||
        this.gsData.status === serviceOrderStatuses.open
      ) {
        this.changeStatus(serviceOrderStatuses.scheduled);
      }
    }
    this.gsData.startDate = event.value;
  }

  changeStatus(status: string) {
    this.status = status;
    this.statusChanged.next(status);
    this.canCheckin = this.canUserCheckin();
  }

  onStartDateFocus(event: any) {
    if (!this.id) {
      this.commonService.showNotification(
        'error',
        `Please save the service order!`
      );
    }
  }

  canUserCheckin() {
    if (
      this.id &&
      (!this.hasCheckedInServiceOrder ||
        (this.hasCheckedInServiceOrder &&
          this.status === serviceOrderStatuses.inProgress)) &&
      this.status !== serviceOrderStatuses.completed &&
      this.status !== serviceOrderStatuses.cancelled &&
      this.status !== serviceOrderStatuses.pendingApproval &&
      !(
        (this.checkInDateReadOnly || this.checkOutDateReadOnly)
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  getCustomerByConfiguration(configuration: string, src?:string) {
    // (`getCustomerByConfiguration() API call (Configuration/GetCustomerInfoByConfiguration): SRC: [${src}], params: [ configuration: ${this.gsData.configuration}]`);

    this.serviceOrderService.popupLoader.next(true);
    this.generalSectionService
      .getCustomerInfoByConfiguration(configuration, this.serialNumberDropdown.value ?? '')
      .subscribe(
        (res: ApiResponse) => {
          if (res && res.result && res.result.length) {
            const data = res.result[0];
            this.gsData.address = data.address;
            this.gsData.customerEmail = data.email;
            this.gsData.businessPartnerStatus = data.businessPartnerStatus;
            this.gsData.addressCode = data.addressCode;
            this.gsData.city = data.city;
            this.gsData.signal = data.signalCodeDescription;
            this.gsData.country = data.country;
            this.gsData.customerPhoneNumber = this.gsData.customerPhoneNumber;
            this.gsData.customerCode = data.soldToBP;
            this.gsData.zipCode = data.zipCode;
            this.gsData.customerPhoneNumber = data.phoneNumber;
            this.gsData.customerCurrency = data.currency;
            this.gsData.taxable = data.taxable !== undefined ? data.taxable : false;
            this.gsData.state = data.stateProvince;
            this.gsData.termsOfPayment = data.termsOfPayment;
            this.gsData.termCodeDescription = data.termCodeDescription;
            this.gsData.customerDescription = data.soldToBP + ' - ' + data.bpDescription;

            this.customerAddress = `${
              this.gsData.customerDescription
                ? this.gsData.customerDescription + '\n'
                : ''
            }${
              this.gsData.address
                ? this.gsData.address + '\n'
                : ''
            }${this.gsData.city || ''}, ${
              this.gsData.state || ''
            } ${this.gsData.zipCode || ''}\n${
              this.gsData.country
            }\n${this.gsData.customerPhoneNumber || ''}\n${
              this.gsData.customerEmail || ''
            }`;
            localStorage.setItem('currency', data.currency);
            this.distanceZoneChanged.emit({
              distanceZone: data.distanceZone,
              currency: data.currency,
            });
          }
          this.serviceOrderService.popupLoader.next(false);
        },
        (error: HttpErrorResponse) => {
          this.serviceOrderService.popupLoader.next(false);
        }
      );
  }
/**
 * Method will be used to set these values in the data
 * @param model | Optional: mapped to itemCode
 * @param itemDescription | Optional: mapped to itemDescription
 * @param serial | Optional: mapped to serialNumber
 */
  setModelSerialValues(model?: string, itemDescription?: string, serial?: string, src?: string) {
    // (`setModelSerialValues(): SRC: [${src}], Model: ${model}, itemDescription: ${itemDescription}, Serial: ${serial}`);
    if ( model != null ) {
      this.eqData.itemCode = model || null;
    }
    if ( itemDescription != null ) {
      this.eqData.itemDescription = itemDescription || null;
    }
    if ( serial != null ) {
      this.eqData.serialNumber = serial || null;
    }
  }

  onConfigurationChange(args: any) {
    if ( args.isInteracted || this.fromCustomerAdvancedSearch ) { // Changed from Dropdown or Customer Advance search

        this.gsData.configuration = args.itemData.value;
        this.gsData.customerDescription = args.itemData.text;
        this.setModelSerialValues('', '', '', `on configuration Change ${this.fromCustomerAdvancedSearch ? ' From Advanced Search':''}`);
        this.getModelsDDL(args.itemData.value, `on configuration change${this.fromCustomerAdvancedSearch ? ' From Advanced Search':''}`);
        this.getSerialNumbersDDL(null, `on configuraton change ${this.fromCustomerAdvancedSearch ? ' From Advanced Search':''}`);
        this.getCustomerByConfiguration(args.itemData.value, `on configuraton change ${this.fromCustomerAdvancedSearch ? ' From Advanced Search':''}`); // should be called after setting configuration value in all use-cases

        if (this.fromCustomerAdvancedSearch) {
          // ('from customer advanced search');
          this.fromCustomerAdvancedSearch = false;
        } else {
          // ('on configuration change from ddl', args);
        }
    } else if ( this.fromSerialNumberAdvanceSearch ) {
      // ('from serial number advanced search');

      // this.getCustomerByConfiguration(this.gsData.configuration); // should be called after setting configuration value in all use-cases
      // this.fromSerialNumberAdvanceSearch = false;
    } else { // On popup open OR ngOnChanges
      if ( this.id && args.value ) { // For update SO, need to call this API to get DistanceZone information
        this.getCustomerByConfiguration(args.value, `on configuraton change on popup open OR ng on changes ${this.fromCustomerAdvancedSearch ? ' From Advanced Search':''}`);
      }
      // ('Customer change on popup open or reset')
    }
    this.configurationChanged.emit(this.gsData.configuration);
    this.serviceOrderService.configurationChange.next({
      configurationId: this.gsData.configuration,
      model: this.eqData.itemCode,
      serialNumber: this.eqData.serialNumber,
      isNationalAccount: this.gsData.isNationalAccount
    })
  }

  updateModelDDL(itemCode, itemDescription) {
    if (this.objectsDDL) {
      this.objectsDDL.dataSource = [{
        value: itemCode,
        text: itemCode + ' - ' + itemDescription,
        description: itemDescription,
        serializedItemGroupCode: this.eqData?.serializedItemGroupCode,
        serializedItemGroupDescription: this.eqData?.serializedItemGroupDescription
      }];
      this.objectsDDL.value = this.eqData.itemCode = itemCode;
      this.eqData.itemDescription = itemDescription;
    }
  }

  updateSerialNumberDDL(data) {
    if ( this.serialNumberDropdown) {
      this.serialNumberDropdown.dataSource = [{ value: data.serialNumber, text: data.alternateSerialNumber.trim()? data.serialNumber + ' - ' + data.alternateSerialNumber.trim() : data.serialNumber , ...data}];
      this.serialNumberDropdown.value = data.serialNumber;
    }
  }

  updateConfigurationDDL(configurationId, customerDescription) {
    if (this.configurationsDDL) {
        this.configurationsDDL.dataSource = [{ value: configurationId, text: customerDescription }];
        this.configurationsDDL.value = configurationId;
    }
  }

  loadCommonFields() {
    const apis = [
      this.generalSectionService.getServiceCenters(this.USER.company),
      this.serviceOrderService.getPriorities(this.USER.company),
      this.generalSectionService.getSignals(this.USER.company),
      this.generalSectionService.getCallgroups(this.USER.company),
      this.serviceOrderService.getReasonsForPausedStatus(this.USER.company),
    ];
    forkJoin(apis).subscribe((res: any) => {
      res[0]?.result && this.loadServiceDepartments(res[0].result);
      res[1]?.result && this.loadPriorities(res[1].result);
      res[2]?.result && this.loadSignals(res[2].result);
      res[3]?.result && this.loadCallgroups(res[3].result);
      res[4]?.result && this.loadReasons(res[4].result);
    });
  }

  loadServiceDepartments(data) {
    this.serviceDepartments = data;
  }

  loadPriorities(data) {
    this.priorities = data.map((row) => {
      return { text: row.description, value: row.value };
    });
    this.gsData.priority =
      this.gsData && this.gsData.priority
        ? this.gsData.priority + ''
        : this.priorities.find((priority) => priority.text === 'Normal').value;
    this.gsData.priorityDescription =
      this.gsData && this.gsData.priorityDescription
        ? this.gsData.priorityDescription + ''
        : 'Normal';
  }

  loadSignals(data) {
    this.signals = data.map((row) => {
      return { text: row.description, value: row.value };
    });
  }

  loadCallgroups(data) {
    this.callgroups = data;
  }

  loadReasons(data) {
    this.reasonsForPause = data;
  }

  loadConfigurations(res) {
    this.isDataReceived = false;
    if ( res?.isSuccessful ) {
      this.configurations = res.result.map((row) => {
        return {
          text: row.soldToBP + ' - ' + row.bpDescription,
          value: row.cluster,
        };
      });
      this.configurationsDDL.dataSource = this.configurations;
      this.isDataReceived = true;
    } else {
      this.commonService.showNotification('error', res.message);
    }
    this.serviceOrderService.popupLoader.next(false);
  }

  // loadSerialNumbers(res) {
  //   if ( res?.isSuccessful ) {
  //     this.serialNumbers = res.result.map((row) => {
  //       row.text = row.value = row.serialNumber;
  //   });
  //   } else {
  //     this.commonService.showNotification('error', res.message);
  //   }
  // }

  initailizeGeneralSectionData() {
    if (!this.gsData) {
    } else {
      this.today = this.gsData.startDate
        ? new Date(this.gsData.startDate)
        : null;
      this.customerAddress = this.gsData.customerDescription
        ? `${
            this.gsData.customerDescription
              ? this.gsData.customerDescription + '\n'
              : ''
          }${
            this.gsData.address
              ? this.gsData.address + '\n'
              : ''
          }${this.gsData.city || ''}, ${
            this.gsData.state || ''
          } ${this.gsData.zipCode || ''}\n${
            this.gsData.country
          }\n${
            this.gsData.customerPhoneNumber
              ? this.gsData.customerPhoneNumber + '\n'
              : ''
          }${this.gsData.customerEmail || ''}`
        : '';
    }
  }

  get isTelephoneValid() {
    const phoneNumberRegex = /^[\d-()+#]{10,20}$/;
    if (this.gsData?.callerPhone)
     return this.validationApplied && this.gsData.callerPhone.replace(/[-()+#]/g, "")?.length > 9 && phoneNumberRegex.test(this.gsData?.callerPhone);
    else return true;
  }

  validateReference(){
    if(this.gsData.reference.length > 30){
      this.commonService.showNotification('error', 'Max. limit for refrence input is 30 characters.');
      return false;
    } else {
      return true;
    }
  }

  validateGeneralSectionData() {
    this.validationApplied = true;
    if ( this.gsData.configuration && this.gsData.callGroup //&& this.isTelephoneValid
      && (this.status !== serviceOrderStatuses.paused 
        || (this.status === serviceOrderStatuses.paused && this.reasonsDDL?.value)) ) {
      if(this.gsData.reference){
        return this.validateReference();
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  onCloseSearchForCustomer(data: any) {
    this.showAdvancedSearch = false;
    if (data) {
        this.fromCustomerAdvancedSearch = true;
        this.gsData.isNationalAccount = data.isNationalAccount;
        this.updateConfigurationDDL(data.cluster, data.soldToBP + ' - ' + data.bpDescription);
        this.setModelSerialValues('', '', '', 'on advance search close for customer');
        // this.serviceOrderService.modelDescriptionChange.next(null);
        // this.serviceOrderService.serialNumberChange.next({ itemData: null });
        // this.serviceOrderService.equipmentInfoSubject.next(null);

        // this.configurationChangeSubscription({ configurationId: data.cluster });
        // this.serviceOrderService.configurationChange.next({ configurationId: data.cluster,  });
    }
  }

  setNotesData() {
    if (!this.notesData) {
        // this.notesData = {
        //     activityText: null,
        //     customerComplaint: null,
        //     fstCommentsToCustomer: null,
        //     notesToCustomerCare: null,
        //     cancellationNotes: null,
        //     reasonCode: null,
        //     reasonDescription: null,
        //     offlineOrder: true
        // };
    }
  }

  validateCommentsNotesData(onInvoicePaymentValidate) {
    this.validationApplied = true;
    if (this.status === serviceOrderStatuses.cancelled  && !this.notesData.reasonCode || onInvoicePaymentValidate && !this.notesData.fstCommentsToCustomer ) {
      return false;
    } else {
      return true;
    }
  }

  getCommentsNotesData() {
    return this.notesData;
  }
  getGeneralSectionData() {
    this.gsData.priority = this.gsData.priority + '';
    this.gsData.businessPartnerStatus = this.gsData.businessPartnerStatus ? this.gsData.businessPartnerStatus : null;
    return this.gsData;
  }

  getEquipmentSectionData() {
    if ([serviceOrderStatuses.completed, serviceOrderStatuses.cancelled].includes(this.eqData.status)) {
      this.eqData.warrantyCoverageLines = JSON.stringify(this.warrantyInfo);
      this.eqData.contractCoverageLines = JSON.stringify(this.contractInfo);
    }
    return this.eqData;
  }

  onTextInput(args, textareaObj) {
    textareaObj.element.style.height = "auto";
    textareaObj.element.style.height = (textareaObj.element.scrollHeight) + "px";
  }

  // getSerialNumbers(isInteracted: boolean) {
  //   this.soDetailsTabService.getSerialNumbers(this.gsData.configuration, this.eqData.itemCode)
  //     .subscribe((res: any) => {
  //         this.serialNumbers = res.result && res.result.length ? res.result : [];
  //         this.serviceOrderService.popupLoader.next(false);
  //     }, (error: HttpErrorResponse) => {
  //         this.serviceOrderService.popupLoader.next(false);
  //     });
  // }

  onCloseSearchForSerialNumbers(data: any) {
    this.showAdvancedSearchForSerialNumbers = false;
    if (data) {
      this.fromSerialNumberAdvanceSearch = true;
      if (this.gsData.configuration) {
          this.commonService.showConfirmation('Customer will change on changing Serial Number. Continue?')
              .then(result => {
                  this.serviceOrderService.popupLoader.next(true);
                  if (result.isConfirmed) {
                    this.gsData.isNationalAccount = data.isNationalAccount;
                    this.updateModelCustomerAfterSerialChange(data);
                    this.eqData.itemCode = data.model;
                    this.updateSerialNumberRelatedData(data);
                    this.getWarrantyAndContract();
                  }
                  this.serviceOrderService.popupLoader.next(false);
              });
      } else {
        this.updateModelCustomerAfterSerialChange(data);
        this.eqData.itemCode = data.model;
        this.updateSerialNumberRelatedData(data);
        this.getWarrantyAndContract();
      }
    }
  }

  updateModelCustomerAfterSerialChange(data) {
    this.objectsDDL.clear();
    this.serialNumberDropdown.clear();
    this.configurationsDDL.clear();
    const configurationDescription = data.customerId + ' - ' + data.customerName;
    this.configurations = [{ value: data.configuration, text: configurationDescription }];
    forkJoin([
      this.soDetailsTabService.getObjects(data.configuration, this.serviceDepartment),
      this.soDetailsTabService.getSerialNumbersForSearch(this.serviceDepartment, this.USER.company, data.configuration, data.model, '', this.gsData.offlineOrder)
    ]).subscribe((res: any) => {
      if ( res[0]?.result ) {
        res[0].result.map(row => {
          row.text = row.value + " - " + row.description;
        });
        this.objectsDDL.dataSource = this.objects = res[0].result;
      }
      if ( res[1]?.result ) {
        res[1].result.map((row) => {
          row.text = row.alternateSerialNumber.trim() ? row.serialNumber + ' - ' + row.alternateSerialNumber.trim() : row.serialNumber;
          row.value = row.serialNumber;
        });
        this.serialNumberDropdown.dataSource = this.serialNumbers = res[1].result;
      }
      this.configurationsDDL.value = this.gsData.configuration = data.configuration;
      this.gsData.customerDescription = configurationDescription;
      this.objectsDDL.value = this.eqData.itemCode = data.model;
      this.eqData.itemDescription = data.modelDescription;
      this.serialNumberDropdown.value = this.eqData.serialNumber = data.serialNumber;

      this.getCustomerByConfiguration(data.configuration);
    });
  }

  // reset() {
  //   this.selectedModelNumber = null;
  //   this.selectedSerialNumber = null;
  //   this.eqData.itemCode = null;
  //   this.eqData.itemDescription = null;
  //   this.serialNumbers = [];
  //   this.eqData.serialNumber = null;
  //   this.eqData.serializedItemGroupCode = null;
  //   this.eqData.serializedItemGroupDescription = null;
  //   this.eqData.category = null;
  //   this.eqData.installationDate = null;
  //   this.eqData.warrantyDescription = null;
  //   this.eqData.warrantyCode = null;
  //   this.eqData.serviceContractCode = null;
  //   this.eqData.serviceContractDescription = null;
  //   this.eqData.calibrationNextCertificateDate = null;
  // }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }
}
